import {Switch} from '@headlessui/react'
import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {twMerge, noop} from '@sdox/utils'

import styles from './toggle.module.scss'

import type {SwitchProps} from '@headlessui/react'

export interface ToggleProps extends Omit<SwitchProps, 'className'> {
  className?: string
}

export const Toggle = (props: ToggleProps) => {
  const {checked: checkedProps, value, onChange = noop, className, name, ...restProps} = props
  const [isChecked, setIsChecked] = useState(checkedProps)
  const {t} = useTranslation()

  useEffect(() => {
    setIsChecked(checkedProps)
  }, [checkedProps])

  const handleChange = (checked: boolean) => {
    setIsChecked(checked)
    onChange(checked)
  }

  return (
    <Switch
      checked={isChecked}
      value={value}
      name={name}
      onChange={handleChange}
      className={twMerge(
        styles.toggle,
        className,
      )}
      {...restProps}
    >
      <span className={'sr-only'}>
        {t('common:toggleTo', {name, value: !isChecked ? t('common:on') : t('common:off')})}
      </span>
      <span
        aria-hidden={'true'}
        className={styles.grabber}
      />
    </Switch>
  )
}
